import { GimliCustomerData } from '@vfde-sails/avc-core';
import { CustomerInfoId } from '../enums/elementId';
import { debugInfo } from '../util/debug';
import { getCustomerCity, getCustomerFullName, getCustomerStreet } from '../util/formatter';

/**
 * Update the content of customer info section
 * @param {GimliCustomerData} customer - Info to update
 */
export const updateCustomerInfo = (customer: GimliCustomerData) => {
    const nameElement = document.getElementById(CustomerInfoId.CUSTOMER_NAME);
    const cityElement = document.getElementById(CustomerInfoId.CUSTOMER_CITY);
    const streetElement = document.getElementById(CustomerInfoId.CUSTOMER_STREET);
    const numberElement = document.getElementById(CustomerInfoId.CUSTOMER_NUMBER);

    if (!nameElement || !cityElement || !streetElement || !numberElement) {
        debugInfo('Could not find customer info elements');
        return;
    }

    nameElement.innerText = getCustomerFullName(customer.customerInfo);
    cityElement.innerText = getCustomerCity(customer.address);
    streetElement.innerText = getCustomerStreet(customer.address);
    numberElement.innerText = customer.customerInfo.accountId;
};
